const ERRORS = {
  network: [
    "Le wifi a lâché en plein effort. Réessaie dans un instant.",
    "J'ai perdu la connexion. Deux secondes, je reviens.",
    "Le réseau fait des siennes. C'est pas moi, promis.",
    "Coupure réseau. Je réessaie dès que ça revient.",
  ],
  ai: [
    "Mon cerveau a bugué. Relance et je me rattrape.",
    "J'ai eu un blanc. Ça arrive même aux meilleurs.",
    "Erreur de ma part. Réessaie, je ferai mieux.",
    "J'ai planté. Pas de panique, je suis déjà dessus.",
  ],
  validation: [
    "Il manque un truc. Vérifie les champs et relance.",
    "J'ai pas tout ce qu'il me faut. Complète et on y retourne.",
  ],
  validation_field: [
    "Ce champ a l'air suspect. Reformule et relance.",
    "Texte trop long ou invalide. Réduis un peu.",
    "J'ai détecté un truc bizarre. Corrige et on repart.",
    "Contenu non conforme. Modifie et réessaie.",
  ],
  workout_ai_prompt: [
    "J'ai besoin d'au moins quelques mots pour générer.",
    "Ta consigne est trop courte. Détaille un peu ce que tu veux.",
    "Un peu plus de contexte et je m'y mets.",
  ],
  moderation: [
    "Ma réponse a été filtrée. Reformule ta demande.",
    "Le contenu généré n'a pas passé le contrôle. On retente ?",
    "Filtrage activé. Essaie une autre formulation.",
    "Réponse bloquée par la modération. Pas de panique, reformule.",
  ],
  mic: [
    "Le micro ne répond pas. Vérifie les autorisations.",
    "Impossible d'accéder au micro. C'est bloqué côté navigateur.",
    "Micro indisponible. Tape à la main, ça marche aussi.",
    "Le micro fait la grève. Autorise l'accès et réessaie.",
  ],
};

const LOADING = {
  ai: [
    "Je fouille dans mes notes…",
    "J'analyse le profil, deux secondes…",
    "Je concocte quelque chose de bien…",
    "Concentration maximale. Ne me dérange pas.",
    "Mon cerveau tourne à plein régime…",
    "Je lis entre les lignes de l'historique…",
    "Séance sur mesure en préparation…",
    "J'étudie le dossier. Sérieusement.",
    "Je cherche LA séance parfaite…",
    "Calculs en cours. Je fais pas semblant.",
  ],
  alternatives: [
    "Je cherche des variantes…",
    "Alternatives en cours de calcul…",
    "Je fouille dans mon catalogue…",
    "Analyse des options en cours…",
  ],
  voice_parse: [
    "J'écoute et je déchiffre…",
    "Analyse vocale en cours…",
    "Je traduis ta voix en données…",
    "Décryptage en cours, deux secondes…",
  ],
  import_clients: [
    "J'importe tes clients…",
    "Lecture du fichier en cours…",
    "Import en cours, patience…",
    "Je mets tout en ordre…",
  ],
  workout_ai: [
    "Je compose les sections et j'aligne les charges…",
    "Je croise historique, matériel et ton style…",
    "Je choisis les bons exos dans la base…",
    "J'équilibre volume et récup…",
    "Je vérifie que la séance tient la route…",
  ],
  /** Sous-ligne statique sous les barres shimmer (drawer IA) — voix 1re personne */
  workout_ai_overlay: [
    "Génération en cours… j’analyse ta consigne et nos réglages.",
    "Ça travaille… je structure les blocs pour que ce soit cohérent.",
  ],
  app_init: [
    "Je me réveille…",
    "Chargement de ton espace…",
    "Mise en place. Deux secondes.",
    "Démarrage en cours…",
  ],
};

const EMPTY = {
  no_clients: [
    "Personne ici pour l'instant. Ajoute ton premier client.",
    "C'est vide. Ton premier client n'attend que toi.",
  ],
  no_sessions: [
    "Aucune séance. C'est le moment de commencer.",
    "Pas encore de séance. Lance-toi.",
  ],
  no_session_history: [
    "Pas d'historique pour l'instant. Les séances s'afficheront ici.",
    "Historique vierge. Les données viendront avec le temps.",
  ],
  no_notes: [
    "Aucune note. Ajoute tes observations ici.",
    "Carnet vide. Dicte ou tape ta première note.",
  ],
  no_tags: [
    "Pas encore de tags. Ajoute-en pour mieux organiser.",
    "Aucun tag. Personnalise le profil de ton client.",
  ],
  no_revenue: [
    "Pas encore de revenus enregistrés.",
    "Les finances apparaîtront ici dès la première séance facturée.",
  ],
  no_events: [
    "Calendrier vide. Planifie ta première séance.",
    "Rien de prévu. Ajoute un créneau pour démarrer.",
  ],
  no_equipment: [
    "Aucun matériel configuré. Renseigne ce que tu as.",
    "Liste de matériel vide. Coche ce que tu possèdes.",
  ],
  no_ai_session: [
    "Pas encore de séance IA. Lance une génération.",
    "L'IA attend ton feu vert. Clique pour générer.",
  ],
};

const CONFIRM = {
  save: [
    "C'est noté.",
    "Sauvegardé.",
    "Bien reçu, tout est en place.",
    "Enregistré. On continue.",
  ],
  replace_workout_ai: [
    "Je remplace toute cette séance par la génération IA ?",
    "Tout effacer ici et injecter ce que l'IA propose ?",
    "On vide les sections actuelles pour la nouvelle séance générée ?",
  ],
};

const TOAST = {
  demo: [
    "Mode démo activé. Les données sont fictives.",
    "Tu es en mode démo. Tout est simulé.",
    "Démo en cours. Rien n'est réel ici.",
    "Mode test activé. Amuse-toi.",
  ],
};

function _pick(pool) {
  return pool[Math.floor(Math.random() * pool.length)];
}

export function getErrorMessage(type) {
  const pool = ERRORS[type] || ERRORS.network;
  return _pick(pool);
}

export function getLoadingMessage(type) {
  const pool = LOADING[type] || LOADING.ai;
  return _pick(pool);
}

export function getEmptyMessage(context) {
  const pool = EMPTY[context] || EMPTY.no_clients;
  return _pick(pool);
}

export function getConfirmMessage(context) {
  const pool = CONFIRM[context] || CONFIRM.save;
  return _pick(pool);
}

export function getToastMessage(context) {
  const pool = TOAST[context] || TOAST.demo;
  return _pick(pool);
}
